module.exports = "dist/e8a427e15cc502bef99cfd722b37ea98.woff2";